import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { fetchScores, formatTime } from "../lib/api";
import { LEVELS } from "../game/maze";
import { useT } from "../i18n";

export const Leaderboard = ({ level, onClose }) => {
  const t = useT();
  const [tab, setTab] = useState(level);
  const [scores, setScores] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setScores(null);
    setError(false);
    fetchScores(tab).then(setScores).catch(() => setError(true));
  }, [tab]);

  return (
    <div className="overlay overlay-top" data-testid="leaderboard-modal" onClick={onClose}>
      <div className="panel panel-enter panel-wide" onClick={(e) => e.stopPropagation()}>
        <div className="board-head">
          <h2 className="title title-sm">{t.leaderboard}</h2>
          <button className="icon-btn" onClick={onClose} data-testid="leaderboard-close-button" aria-label={t.close}>
            <X size={16} />
          </button>
        </div>
        <div className="board-tabs" role="tablist">
          {Object.keys(LEVELS).map((key) => (
            <button
              key={key}
              role="tab"
              aria-selected={tab === key}
              className={`board-tab ${tab === key ? "active" : ""}`}
              onClick={() => setTab(key)}
              data-testid={`leaderboard-tab-${key}`}
            >
              {t.levels[key]}
            </button>
          ))}
        </div>
        {error && <p className="error">{t.boardError}</p>}
        {!error && !scores && <p className="lead">{t.loading}</p>}
        {scores && scores.length === 0 && (
          <p className="lead" data-testid="leaderboard-empty">{t.empty}</p>
        )}
        {scores && scores.length > 0 && (
          <table className="board" data-testid="leaderboard-table">
            <thead>
              <tr><th>#</th><th>{t.name}</th><th>{t.time}</th></tr>
            </thead>
            <tbody>
              {scores.map((s, i) => (
                <tr key={s.id} data-testid={`leaderboard-row-${i}`}>
                  <td>{i + 1}</td><td>{s.name}</td><td>{formatTime(s.time_ms)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
